export const blockIconsDeviceFmdGood = (
	<span className='material-symbols-outlined'>fmd_good</span>
);
